import { useState } from "react";

import { translate } from "../lib/translate";

type Props = {
  getCn: () => string;
  getEn: () => string;
  setCn: (v: string) => void;
  setEn: (v: string) => void;
  title?: string;          // 可选：标识字段名，用于错误提示
  vertical?: boolean;      // 上下布局（中在上、英在下）时用上下箭头
};

/**
 * 中英双向翻译按钮（一对符号按钮）：
 *   左右布局：译→ 中译英 / ←译 英译中
 *   上下布局（vertical）：译↓ 中译英 / 译↑ 英译中
 * 仅用符号，夹在中文/英文输入框之间。
 */
export function TransButtons({ getCn, getEn, setCn, setEn, title, vertical }: Props) {
  const [busy, setBusy] = useState<null | "en" | "zh">(null);
  const [err, setErr] = useState<string | null>(null);

  const run = async (to: "en" | "zh") => {
    const src = to === "en" ? getCn() : getEn();
    if (!src.trim()) return;
    setErr(null);
    setBusy(to);
    try {
      const out = await translate(src, to);
      if (to === "en") setEn(out); else setCn(out);
    } catch (e) {
      const msg = (e as { body?: { message?: string } })?.body?.message;
      setErr(msg || (e as Error).message || "翻译失败");
    } finally {
      setBusy(null);
    }
  };

  return (
    <span className="trans-btns" title={title}>
      <button type="button" className="trans-btn" disabled={busy !== null}
        title="中译英" onClick={() => run("en")}>
        {busy === "en" ? "…" : (vertical ? "译↓" : "译→")}
      </button>
      <button type="button" className="trans-btn" disabled={busy !== null}
        title="英译中" onClick={() => run("zh")}>
        {busy === "zh" ? "…" : (vertical ? "译↑" : "←译")}
      </button>
      {err && <span className="trans-err" title={err}>!</span>}
    </span>
  );
}
